import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.maac_user_assigned_uid !== model.maac_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.maac_user_modified_uid,
						assignedTo: modifiedModel.maac_user_assigned_uid,
						title: 'Nuova Azione di Marketing assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.maac_title}".`,
						url: `${window.location.origin}/marketingactions/details/${model.maac_uid}`,
						icon: 'bullhorn',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
